/* eslint-disable react/no-array-index-key */
import React, { useRef } from 'react';
import Slider from 'react-slick';
import { Box } from '@mui/material';
import { Grid } from '@mui/system';
import quote from './quote.svg';
import star from './Union.svg';
import SliderButton from '../../../components/SliderButton/SliderButton';

const SuccessStories = ({ successStories }) => {
  const sliderRef = useRef(null);
  const settings = {
    arrows: false,
    infinite: true,
    slidesToShow: 2.08,
    slidesToScroll: 1,
    autoplay: false,
    speed: 700,
    focusOnSelect: true,
    autoplaySpeed: 500,
    cssEase: 'linear',
    pauseOnHover: true,
    pauseOnFocus: true,
    centerMode: true,
    dots: true,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1.8, // Adjust for tablets
          slidesToScroll: 1,
          arrows: false,
          centerMode: false,
          swipeToSlide: true,
          autoplay: false,

        },
      },
      {
        breakpoint: 899,
        settings: {
          slidesToShow: 1.5, // Adjust for mobile
          slidesToScroll: 1,
          arrows: false,
          centerMode: false,
          swipeToSlide: true,
          autoplay: false,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1, // Adjust for mobile
          slidesToScroll: 1,
          arrows: false,
          centerMode: false,
          swipeToSlide: true,
          autoplay: false,
          dots: true,
        },
      },
    ],
  };

  return (
    <Grid
      className="sucess-section-wrap"
      sx={{
        justifyContent: 'center',
      }}>
      <Grid
        container
        sx={{
          justifyContent: 'space-between',
        }}
        className="section-top">
        <Grid size={{ xs: 12, md: 7 }}>
          <h2 className="box-title">{successStories.title}</h2>
          <p className="box-subtitle">
            {successStories.subTitle}
          </p>
        </Grid>
        <Grid
          container
          size={5}
          sx={{
            justifyContent: 'flex-end',
            gap: '16px',
            display: { md: 'flex', xs: 'none' },
          }}>
          <SliderButton size="44px" onClick={() => sliderRef.current.slickPrev()} />
          <SliderButton isNext size="44px" onClick={() => sliderRef.current.slickNext()} />
        </Grid>
      </Grid>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ margin: { xs: '0px 20px 72px', md: '32px 0px 100px 80px' } }}>
          <Slider ref={sliderRef} {...settings}>
            {successStories?.cardList?.map((testimonial, index) => (
              <Box key={index} sx={{ marginRight: '16px' }}>
                <Box
                  sx={{
                    padding: { md: '42px', xs: '24px' },
                    boxShadow: '0px 3px 4px 0px #00000014',
                    border: '1px solid #EFF6E0',
                    borderRadius: '18px',
                    position: 'relative',
                    height: { md: '300px', xs: '250px' },
                    marginRight: { md: '30px', xs: '20px' },
                    width: { xs: '100%', md: 'auto' },
                  }}
                  className="slides-card"
                >
                  <div className="title">
                    {testimonial.title}
                  </div>
                  <div className="description">
                    {testimonial.description}
                  </div>
                  <Box className="card-bottom">
                    <div className="bottom-left">
                      <img className="author-image" width={72} height={72} src={`${testimonial?.authorImage?.url}`} alt={testimonial.name} />
                      <Box>
                        <div className="name">{testimonial.authorName}</div>
                        <div className="occupation">{testimonial.authorDesignation}</div>
                        <div className="stars">
                          <img src={star} alt="star" />
                          <img src={star} alt="star" />
                          <img src={star} alt="star" />
                          <img src={star} alt="star" />
                          <img src={star} alt="star" />
                        </div>
                      </Box>
                    </div>
                    <div className="bottom-right"><img src={quote} alt="quote" width={28} /></div>
                  </Box>
                </Box>
              </Box>
            ))}
          </Slider>
        </Box>
      </Box>
    </Grid>
  );
};

export default SuccessStories;
